export enum QueryKeys {
    OnboardedSensors = 'onboardedSensors',
    OnboardedSensorsTagsList = 'onboardedSensorsTagsList',
    OnboardedSensorsTagsDetails = 'onboardedSensorsTagsDetails',
    Plants = 'plants',
    PlantStatusAccess = 'plantStatusAccess',
    Projects = 'projects',
    UserSettings = 'userSettings',
    Devices = 'devices',
    Protocols = 'protocols',
    Measurements = 'measurements',
    Systems = 'systems',
    Areas = 'areas',
    FilteredTags = 'filteredTags',
    StidTagSearch = 'stidTagSearch',
    SuperiorTags = 'superiorTags',
    VendorSerialNumbers = 'vendorserialnumbers',
    TagDetails = 'tagDetails',
    Trends = 'trends',
    DownlinkCapability = 'downlinkCapability',
    Configurations = 'configurations',
    SensorImages = 'sensorImages',
}
